import * as Lodash from 'lodash'

import { KV, mapFromKVs } from './object'

export const isPromise = (obj: any) =>
  'then' in obj && Lodash.isFunction(obj.then)

export const resolve = async (value: any) => {
  if (Lodash.isFunction(value)) {
    const result = await value()
    return result
  } else {
    const result = isPromise(value) ? await value : value
    return result
  }
}

export const resolveAll = async (promiseMap: any) => {
  const keys = Object.keys(promiseMap)
  const promises = keys.map(async (key) => {
    const value = promiseMap[key]
    const resolved = await resolve(value)
    return [key, resolved] as KV
  })

  const resolvedKVs = await Promise.all(promises)

  return mapFromKVs(resolvedKVs)
}

export async function sequentialAll<T>(
  producers: Array<() => Promise<T>>,
): Promise<T[]> {
  const results = []

  for (const producer of producers) {
    const result = await producer()
    results.push(result)
  }

  return results
}
